import { getItem } from '../../helpers/storage';

export const isMylqaSubscriptionActive = (userData) => {
    const brandSelectionFromLocalStorage = getItem('cachedHotelSelected');
    const selectedBrand = getItem('cachedBrandSelected');

    if (!brandSelectionFromLocalStorage && !selectedBrand) {
        return false;
    }

    let selectedHotel;
    if (userData && userData.brands) {
        const getSelectedBrand = userData.brands.find(brand => brand.id === parseInt(selectedBrand));
        if (!getSelectedBrand) {
            return false;
        }
        for (const hotel of getSelectedBrand.hotels) {
            if (hotel.id === brandSelectionFromLocalStorage) {
                selectedHotel = hotel;
                break;
            }
        }
    }

    return selectedHotel && selectedHotel.myLqaSubscriptionPurchased;
};
